import LoginApi from "../api/login/LoginApi";
import request from "@/api/Request";
import StorageManager from "./StorageManager";
const basicLoginKey = "basic-login-key";

export default {
    async set(username, password) {
        let basicLogin = await LoginApi.basicLogin({
            username: username,
            password: password
        });
        console.log("basic login status: " + basicLogin);
        if (basicLogin) {
            StorageManager.setItem(basicLoginKey, username + "||" + password)
        } else {
            StorageManager.removeItem(basicLoginKey)
        }
        request.defaults.headers.common['BasicLogin'] = username + "||" + password;
        return basicLogin;
    },
    get() {
        return StorageManager.getItem(basicLoginKey)
    },
    clear() {
        StorageManager.removeItem(basicLoginKey)
    },
    loggedIn() {
        return !!StorageManager.getItem(basicLoginKey)
    }
}